'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EditorSelector = require('./components/EditorSelector.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EditorSelector).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/editor-selector/index.js
// module id = 1294
// module chunks = 0